// extracted by mini-css-extract-plugin
export default {"dialogBox":"EditSuggestedQuestion_dialogBox__FFwie","closeButton":"EditSuggestedQuestion_closeButton__Cs1MP","placeholder":"EditSuggestedQuestion_placeholder__qpO6L"};